import { Capability } from "../formElementCapability";
import IFormElementSchema from "./iFormElementSchema";
import { baseRestrictions, formElementsSchema, restrictionSchema } from "./mmccProviderValidationSchema";
import TemplateElement from "./templateElement";

export default class MMCCProviderValidation extends TemplateElement {

  _elementRestrictions: Array<Array<Capability>> = [baseRestrictions];
  restrictionSchema: object = restrictionSchema;
  formElementsSchema: Array<IFormElementSchema> = formElementsSchema;

  get controlName(): string {
    return "Provider Verification";
  }

  get controlIcon(): string {
    return 'icon puzzle-piece';
  }
}
